import PropTypes from 'prop-types';
import { forwardRef } from 'react';
// @mui
import {
  SvgDocxFill,
  SvgImgFill,
  SvgPdfFill,
  SvgPptFill,
  SvgXlsFill,
} from '../SvgIcons';
import { FILE_EXTENSION } from '../../store/types';
//



// =====================================|| File Icon ||===================================== //
const FileIcon = forwardRef(({ color, size = 24, type = FILE_EXTENSION.pdf, title, description, sx, ...other }, ref) => {
  const icon = {
    [FILE_EXTENSION.png]:  <SvgImgFill  size={size} color={color} />,
    [FILE_EXTENSION.jpg]:  <SvgImgFill  size={size} color={color} />,
    [FILE_EXTENSION.jpeg]: <SvgImgFill  size={size} color={color} />,
    [FILE_EXTENSION.pdf]:  <SvgPdfFill  size={size} color={color} />,
    [FILE_EXTENSION.xls]:  <SvgXlsFill  size={size} color={color} />,
    [FILE_EXTENSION.xlsx]: <SvgXlsFill  size={size} color={color} />,
    [FILE_EXTENSION.docx]: <SvgDocxFill size={size} color={color} />,
    [FILE_EXTENSION.pptx]: <SvgPptFill  size={size} color={color} />,
    [FILE_EXTENSION.txt]:  <SvgDocxFill  size={size} color={color} />,
    [FILE_EXTENSION.text]: <SvgDocxFill  size={size} color={color} />,
  }

  return (icon[type]);
});

FileIcon.propTypes = {
  sx: PropTypes.object,
  description: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.oneOf([
    FILE_EXTENSION.pdf,
    FILE_EXTENSION.xlsx,
    FILE_EXTENSION.xls,
    FILE_EXTENSION.docx,
    FILE_EXTENSION.pptx,
    FILE_EXTENSION.jpg,
    FILE_EXTENSION.jpeg,
    FILE_EXTENSION.png,
    FILE_EXTENSION.txt,
    FILE_EXTENSION.text
  ]),
};

export default FileIcon;
